export const IN_FLIGHT_MEAL_TYPE: Record<string, string> = {
  preOrder: 'label.preordermealtype',
  special: 'label.specialMeal',
  ancillary: 'label.chargeableMeal',
};
